import { Diagnostic } from './Diagnostic';
export class Troubleshooting extends Diagnostic {
    constructor(param) {
        super({ ...param, type: 'TROUBLESHOOTING' });
    }
}
